import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import TextButton from 'components/TextButton'
import Stack from '@mui/material/Stack'

const VARIANTS = {
  tertiary: {
    color: 'tertiary',
    backgroundColor: 'rgba(0, 160, 255, .1)',
  },
  error: {
    color: 'error',
    backgroundColor: 'rgba(255, 0, 0, .1)',
  },
  warning: {
    color: 'warning',
    backgroundColor: 'rgba(255, 134, 0, 0.1)',
  },
}

const PaperBottomButton = ({
  variant,
  icon,
  noBorder,
  noSelect,
  children,
  ...props
}) => (
    <Stack
      display="grid"
      gridAutoFlow="column"
      p={1.5}
      gap={1}
      sx={theme => ({
        borderTop: noBorder ? undefined : `1px solid ${theme.palette.border.main}`,
        placeItems: 'center',
        placeContent: 'center',
        backgroundColor: VARIANTS[variant]?.backgroundColor,
        cursor: noSelect ? undefined : 'pointer',
      })}
      {...props}
    >
      {icon && (
        <Icon
          icon={icon}
        />
      )}
      <TextButton
        color={VARIANTS[variant]?.color}
      >
        {children}
      </TextButton>
    </Stack>
  )

PaperBottomButton.propTypes = {
  variant: PropTypes.oneOf(Object.keys(VARIANTS)),
  icon: PropTypes.string,
  noBorder: PropTypes.bool,
  noSelect: PropTypes.bool,
}

PaperBottomButton.defaultProps = {
  variant: 'tertiary',
}

export default PaperBottomButton